export const removeHashtagLinks = (html: string) => {
  const div = document.createElement('div')

  div.innerHTML = html

  const tagsList = div.querySelectorAll('.hashtag')
  const tagsArr = Array.from(tagsList) as HTMLAnchorElement[]

  for (let ix = 0; ix < tagsArr.length; ix++) {
    const tagEle = tagsArr[ix];

    const innerHTML = tagEle.innerHTML
    
    tagEle.outerHTML = innerHTML
  }

  const newHTML = div.innerHTML

  return newHTML
}
